import React from 'react';
import { formatFilterDecisionLabel } from '../../../utils/accuracyEvidenceMeta';
import styles from '../css/index.module.css';

const TONE_CLASS = {
    include: styles.aiWardenEvidenceDecisionInclude,
    context_only: styles.aiWardenEvidenceDecisionContext,
    exclude: styles.aiWardenEvidenceDecisionExclude,
    contradiction_candidate: styles.aiWardenEvidenceDecisionContradiction,
};

const EvidenceDecisionBadge = ({ decision, label }) => {
    const text = label || formatFilterDecisionLabel(decision);
    if (!text) return null;
    const key = String(decision || '').toLowerCase().trim();
    const tone = TONE_CLASS[key] || styles.aiWardenEvidenceDecisionNeutral;
    return (
        <span className={`${styles.aiWardenEvidenceDecisionBadge} ${tone}`}>{text}</span>
    );
};

export default EvidenceDecisionBadge;
